import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import {
  convertToSiteTimeZone,
  convertDateTimeFormat,
  convertParseDateTime,
  Utility,
} from 'src/app/shared/utils/utility.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { CONSTANTS } from '../../../shared/constants/constants';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-access-time',
  templateUrl: './access-time.component.html',
  styleUrls: ['./access-time.component.scss'],
})
export class AccessTimeComponent implements OnInit, AfterViewChecked {
  [x: string]: {};
  private timeZone: string;
  @Input() formGroupName!: string;
  formGroup!: FormGroup;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  toggleDateForm = false;
  toggletimeForm = false;
  submited = false;
  errorMessage!: string;
  utility = Utility;

  @Input() skipStepBuilding: boolean = false;
  @Input() isUserProfileFlow!: boolean;
  // Optional display overrides; defaults keep the add-user look.
  @Input() headerTitleKey = 'USER_ADD_USER';
  @Input() subtitleKey = 'ACCESS_TIME_DEFINE_ACCESS_TIME_FOR_NEW_USER';
  @Input() timeFormTitleKey = '';
  @Input() timeZoneLabel = '';
  @Input() showSkip = true;
  @Output() submitToParent = new EventEmitter();
  @ViewChild('accessTime') accessTime!: ElementRef;

  defaultStartTime: any;
  formGroupUserDetail!: FormGroup;
  calendarDate: any;
  startTimeObj: any;
  hour = '';
  minute = '';
  meridiem = '';

  readonly LANG_CONST = LANG_CONST;

  hourStartRepeatTime = '';
  minuteStartReapeatTime = '';
  meridiemStartRepeatTime = '';

  hourEndRepeatTime = '';
  minuteEndReapeatTime = '';
  meridiemEndRepeatTime = '';
  weekArray: any;
  calendarValidateMinMax = '';
  calendarConvertedStartDate: Date;
  calendarConvertedEndDateMinimum = new Date();
  calendarMaxValue = new Date();
  /**
   * @description control getter formgroup
   * @returns rective controls
   */
  get formInstance() {
    return this.formGroup.controls;
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    private cdf: ChangeDetectorRef,
    private stateManagementService: StateManagementService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {
    this.calendarConvertedEndDateMinimum = new Date();
    const siteTimeZone =
      this.stateManagementService.getSharedData()?.selectedSite?.siteTimeZone;
    siteTimeZone
      ? (this.timeZone = siteTimeZone.toString())
      : (this.timeZone = '');
    this.calendarConvertedStartDate = convertToSiteTimeZone(this.timeZone);
  }

  /**
   * @description this is onInit life cycle method
   *  get formgroup from parent rootgroup
   * initialise weekly list
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.formGroupUserDetail = this.rootFormGroup.control.get(
      'userDetails'
    ) as FormGroup;
    this.calendarMaxValue = new Date(CONSTANTS.MAX_CALENDER_YEAR);
    // weekly state manager for select unselect week
    this.weekArray = JSON.parse(
      JSON.stringify(this.translate.instant('WEEKARRAY'))
    );

    this.setInitialStatusSelected();
    this.defaultStartTime = convertDateTimeFormat(
      new Date().toString(),
      `EEE, MMM do, yyyy 'at' h:mm a`
    );
  }

  /**
   * @description if control have it any value mark status true
   * @returns void
   */
  setInitialStatusSelected(): void {
    this.formInstance.repeatDays?.value?.map((day: any) => {
      this.weekArray.find((x: any) => x.value == day).active = true;
    });
  }

  /**
   * @description navigate back button form previous step
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit(
      (this.stepper += -1 + (this.skipStepBuilding ? -1 : 0))
    );
    if (this.isUserProfileFlow) {
      this.stepperChange.emit((this.stepper = 3));
    }
  }

  /**
   * @description validate form if form valid redirect to other stepper
   * @returns void
   */
  submit(): void {
    this.submited = true;

    if (this.formGroup.invalid) return;

    // reset selected repeat days
    this.weekArray.forEach((x: any) => {
      x.active = false;
    });

    this.stepperChange.emit((this.stepper += 1));
  }

  /**
   * @description validate form if form valid redirect to other stepper
   * @returns void
   */
  done(): void {
    this.submited = true;
    if (this.formGroup.invalid) return;
    this.submitToParent.emit(); //submit parent form
  }
  ngAfterViewChecked(): void {
    if (this.accessTime && this.accessTime.nativeElement) {
      this.accessTime.nativeElement.focus();
    }
  }
  /**
   * @description toggle main form and time picker module and spit value editable for user
   * selected input pass for min and max validation
   * @param date
   * @returns void
   */
  selectDate(date: any, selectedInputName: string): void {
    this.formInstance.expireTime.markAsTouched();
    this.formInstance.startTime.markAsTouched();
    this.dateConversionforCalendar(selectedInputName);
    this.toggleDateForm = !this.toggleDateForm;
    this.calendarDate = date;
  }

  /**
   * @description date conversion for calendar format
   * @param selectedInputName date
   */
  dateConversionforCalendar(selectedInputName: string) {
    const startTime = this.formInstance['startTime']?.value;
    const expireTime = this.formInstance['expireTime']?.value;

    if (selectedInputName === 'startTime' && expireTime) {
      this.calendarMaxValue = new Date(
        convertParseDateTime(
          expireTime,
          "EEE, MMM do, yyyy 'at' h:mm a",
          'yyyy-MM-dd'
        )
      );
    } else if (selectedInputName === 'expireTime' && startTime) {
      this.calendarConvertedStartDate = new Date(
        convertParseDateTime(
          startTime,
          "EEE, MMM do, yyyy 'at' h:mm a",
          'yyyy-MM-dd'
        )
      );
      this.calendarMaxValue = new Date(CONSTANTS.MAX_CALENDER_YEAR);
    } else if (
      selectedInputName === 'expireTime' &&
      !startTime &&
      !expireTime
    ) {
      this.calendarMaxValue = new Date(CONSTANTS.MAX_CALENDER_YEAR);
      this.calendarConvertedStartDate = convertToSiteTimeZone(this.timeZone);
    }

    this.calendarValidateMinMax = selectedInputName;
  }

  /**
   * @description mat-calendar output method call and pass value into reactive control
   * @param value date
   * @returns void
   */
  updateFormDate(value: any): void {
    this.calendarDate.value = value;
  }

  /**
   * @description clear variable if value higher than given condition
   * @param ev current event target value reset if value higher than hour
   *  @returns void
   */
  checkHour(ev: any, type: 'start' | 'end' | 'general' = 'general'): void {
    if (
      ev.target.value > 12 ||
      ev.keyCode === 69 ||
      ev.keyCode === 187 ||
      ev.keyCode === 189 ||
      ev.keyCode === 107 ||
      ev.keyCode === 109 ||
      ev.target.value.length > 2
    ) {
      if (type === 'start') {
        this.hourStartRepeatTime = '';
        this.meridiemStartRepeatTime = '';
      } else if (type === 'end') {
        this.hourEndRepeatTime = '';
        this.meridiemEndRepeatTime = '';
      } else {
        this.hour = '';
        this.meridiem = '';
      }
    }
  }

  /**
   * @description clear variable if value higher than given condition
   * @param ev current event target value reset if value higher than minutes
   * @returns void
   */
  checkMinutes(ev: any, type: 'start' | 'end' | 'general' = 'general'): void {
    if (
      ev.target.value > 59 ||
      ev.keyCode === 69 ||
      ev.keyCode === 187 ||
      ev.keyCode === 189 ||
      ev.keyCode === 107 ||
      ev.keyCode === 109 ||
      ev.target.value.length > 2
    ) {
      if (type === 'start') {
        this.minuteStartReapeatTime = '';
        this.meridiemStartRepeatTime = '';
      } else if (type === 'end') {
        this.minuteEndReapeatTime = '';
        this.meridiemEndRepeatTime = '';
      } else {
        this.minute = '';
        this.meridiem = '';
      }
    }
  }

  /**
   * @description reset local variables state
   * @returns void
   */
  resetForm(): void {
    this.hour = '';
    this.minute = '';
    this.meridiem = '';

    this.hourStartRepeatTime = '';
    this.minuteStartReapeatTime = '';
    this.meridiemStartRepeatTime = '';

    this.hourEndRepeatTime = '';
    this.minuteEndReapeatTime = '';
    this.meridiemEndRepeatTime = '';
    this.errorMessage = ''; // empty start time and time message
    this.calendarConvertedStartDate = convertToSiteTimeZone(this.timeZone);
  }

  /**
   * @description after selected value from calendar picker need to transform value for view
   * @returns void
   */
  submitDateTime(): void {
    if (
      this.calendarDate.value &&
      !isNaN(Number(this.hour)) &&
      !isNaN(Number(this.minute)) &&
      this.meridiem
    ) {
      const calendarValue = convertDateTimeFormat(
        this.calendarDate.value,
        'yyyy-MM-dd'
      );
      const formatedDate = convertDateTimeFormat(
        `${calendarValue} ${this.hour}:${this.minute} ${this.meridiem}`,
        "EEE, MMM do, yyyy 'at' h:mm a"
      );

      this.formInstance[this.calendarDate.name].setValue(formatedDate);
      this.resetForm();
    } else {
      this.formInstance[this.calendarDate.name].setValue('');
      this.resetForm();
    }

    this.toggleDateForm = !this.toggleDateForm;
    this.calendarValidateMinMax = '';
  }

  /**
   * @description function will reset current control value
   * @param ev control pass
   * @returns void
   */
  removeValue(ev: any, selectedInputName: string): void {
    ev.setValue('');
    this.dateConversionforCalendar(selectedInputName);
  }

  /**
   * @description repeat event fire after reapt true and add and remove necessary controls
   * @returns void
   */
  changeRepeat(el: HTMLElement): void {
    // need settimeout hack because html not render into dom
    setTimeout(() => {
      el?.scrollTo({
        left: 0,
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    }, 0);

    if (this.formInstance.repeat.value) {
      this.formInstance.startTime?.patchValue('');
      this.formInstance.expireTime?.patchValue('');
      this.addNewControl('repeatStartTime');
      this.addNewControl('repeatEndTime');
      this.addNewControl('repeatDays', true);
      this.formInstance?.repeatStartTime?.markAsTouched();
      this.formInstance?.repeatEndTime?.markAsTouched();
      this.formInstance?.repeatDays?.markAsTouched();
      this.resetForm();
    } else {
      this.resetRepeatCheck();
    }
  }

  resetRepeatCheck(): void {
    this.weekArray.forEach((x: any) => {
      x.active = false;
    });

    if (this.formGroup.contains('repeatStartTime')) {
      this.removeControl('repeatStartTime');
    }

    if (this.formGroup.contains('repeatEndTime')) {
      this.removeControl('repeatEndTime');
    }

    if (this.formGroup.contains('repeatDays')) {
      this.removeControl('repeatDays');
    }
  }

  /**
   * @description add new control for form control
   * @param controlName control name for creation
   * @returns void
   */
  addNewControl(controlName: string, required = false): void {
    let dCtrl = new FormControl();
    if (required) {
      dCtrl.setValidators(MFValidators.required);
    }
    this.formGroup.addControl(controlName, dCtrl);
    dCtrl.updateValueAndValidity();
  }

  /**
   * @description delete control dynamic from form group
   * @param controlName control name string given
   * @returns void
   */
  removeControl(controlName: string): void {
    this.formGroup.removeControl(controlName);
  }

  /**
   * @description set control select time into relavant variables for time edit case
   * @param time
   * @returns void
   */
  selectTime(time: any): void {
    this.toggletimeForm = !this.toggletimeForm;
    if (time.length > 0) {
      const repeatStartTimeobj = time[0]?.value; // start time
      const repeatEndTimeobj = time[1]?.value; // end time
      this.setStartTime(repeatStartTimeobj);
      this.setEndTime(repeatEndTimeobj);
    }
    this.startTimeObj = time;
  }

  /**
   * @description if start time contain value populate into object
   * @param repeatStartTimeobj  object of {value:'', name:''}
   * @returns void
   */
  setStartTime(repeatStartTimeobj: any): void {
    // set start time object value into control
    if (repeatStartTimeobj) {
      this.hourStartRepeatTime = repeatStartTimeobj.split(' ')[0].split(':')[0];
      this.minuteStartReapeatTime = repeatStartTimeobj
        .split(' ')[0]
        .split(':')[1];
      this.meridiemStartRepeatTime = repeatStartTimeobj.split(' ')[1];
    }
  }

  /**
   * @description if start time contain value populate into object
   * @param repeatStartTimeobj  object of {value:'', name:''}
   * @returns void
   */
  setEndTime(repeatEndTimeobj: any): void {
    // set end time object value into control
    if (repeatEndTimeobj) {
      this.hourEndRepeatTime = repeatEndTimeobj.split(' ')[0].split(':')[0];
      this.minuteEndReapeatTime = repeatEndTimeobj.split(' ')[0].split(':')[1];
      this.meridiemEndRepeatTime = repeatEndTimeobj.split(' ')[1];
    }
  }

  /**
   * @description check starttime & endtime endtime alway greater than start time
   * @returns boolean case
   */
  endTimeGrtThanStartTime(): boolean {
    let result = false;
    const startTime = new Date(
      convertParseDateTime(
        `${this.hourStartRepeatTime}:${this.minuteStartReapeatTime} ${this.meridiemStartRepeatTime}`,
        `hh:mm a`,
        `yyyy/MM/dd hh:mm a`
      )
    );
    const endTime = new Date(
      convertParseDateTime(
        `${this.hourEndRepeatTime}:${this.minuteEndReapeatTime} ${this.meridiemEndRepeatTime}`,
        `hh:mm a`,
        `yyyy/MM/dd hh:mm a`
      )
    );
    if (endTime.getTime() > startTime.getTime()) {
      result = true;
    }
    return result;
  }

  /**
   * @description set hours, minutes, meridiem into control
   * @returns void
   */
  submitStartTime(): void {
    if (
      !isNaN(Number(this.hourStartRepeatTime)) &&
      !isNaN(Number(this.minuteStartReapeatTime)) &&
      this.meridiemStartRepeatTime &&
      !isNaN(Number(this.hourEndRepeatTime)) &&
      !isNaN(Number(this.minuteEndReapeatTime)) &&
      this.meridiemEndRepeatTime &&
      this.endTimeGrtThanStartTime()
    ) {
      this.formInstance[this.startTimeObj[0].name].setValue(
        convertParseDateTime(
          `${this.hourStartRepeatTime}:${this.minuteStartReapeatTime} ${this.meridiemStartRepeatTime}`,
          'hh:mm a',
          'hh:mm a'
        )
      );

      this.formInstance[this.startTimeObj[1].name].setValue(
        convertParseDateTime(
          `${this.hourEndRepeatTime}:${this.minuteEndReapeatTime} ${this.meridiemEndRepeatTime}`,
          'hh:mm a',
          'hh:mm a'
        )
      );

      this.toggletimeForm = !this.toggletimeForm;
      this.resetForm();
    } else {
      this.errorMessage = this.translate.instant(
        'FAILED_END_TIME_GREATER_START_TIME'
      );
      this.formInstance[this.startTimeObj[0].name].setValue('');
      this.formInstance[this.startTimeObj[1].name].setValue('');
    }
  }

  /**
   * @description find index and updated latest array value into control
   * @param week get object of week
   * @returns void
   */
  AddRemoveDays(week: any): void {
    const index = this.weekArray.findIndex((x: any) => x.value === week.value);
    this.weekArray[index].active = !week.active;
    this.formInstance.repeatDays.patchValue(
      this.weekArray.filter((x: any) => x.active).map((y: any) => y.value)
    );
  }

  resetToggleFormState() {
    this.hour = '';
    this.minute = '';
    this.meridiem = '';

    this.hourStartRepeatTime = '';
    this.minuteStartReapeatTime = '';
    this.meridiemStartRepeatTime = '';

    this.hourEndRepeatTime = '';
    this.minuteEndReapeatTime = '';
    this.meridiemEndRepeatTime = '';

    this.toggleDateForm = false;
    this.toggletimeForm = false;
  }

  /**
   * @description this method closes the error message alert.
   */
  closeError(): void {
    this.errorMessage = '';
  }
}
